// material
import { alpha } from '@material-ui/core/styles';
import { IconButton, Tooltip } from '@material-ui/core';
import { Icon } from '@iconify/react';
import sunFill from '@iconify/icons-eva/sun-fill';
import moonFill from '@iconify/icons-eva/moon-fill';
// hooks
import { useThemeMode } from '../../theme';

// ----------------------------------------------------------------------

export default function ThemeModeToggle() {
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        onClick={toggleMode}
        sx={{
          width: 40,
          height: 40,
          color: 'text.primary',
          '&:hover': {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          }
        }}
      >
        <Icon icon={isDark ? sunFill : moonFill} width={20} height={20} />
      </IconButton>
    </Tooltip>
  );
}
